import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { getUserDisplayName } from 'utils/user';
import { LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';
export const ConversationOffered = ({ entry, }) => {
    const text = (_jsxs(_Fragment, { children: ["Conversation is offered to", ' ', entry.agents.map((agent, i) => (_jsxs(React.Fragment, { children: [_jsx(UserLink, Object.assign({ userId: agent.id }, { children: getUserDisplayName(agent) })), i !== entry.agents.length - 1 ? ', ' : ' '] }, `conversation-offered-${agent.id}`))), entry.queue_label ? `in ${entry.queue_label} queue` : ''] }));
    return _jsx(LogEntry, { entry: entry, text: text });
};
